import React from "react";
import Loader from "../../../components/Loader";
import NoData from "../../../components/NoData";
import moment from "moment";
import { CiSearch } from "react-icons/ci";
import { MdPreview } from "react-icons/md";

const BalanceLog = (props) => {
  const {
    userId,
    rows,
    loading,
    page,
    pagination,
    limit,
    setLimit,
    setPage,
    user,
    setDetailsOpen,
    setDetailsLoading,
    setDetails,
    openDetails,
  } = props;
  return (
    <div>
      {loading ? (
        <Loader message="Loading transactions..." />
      ) : rows.length === 0 ? (
        <NoData
          message="No Balance Log Found"
          subText="Try changing date range or search keyword."
        />
      ) : (
        <>
          <div className="tx-table-bpl-scroll">
            <div className="tx-table-header-blog">
              {/* {userId && (
                            <div>User</div>
                        )} */}
              <div>Date</div>
              <div>Reference</div>
              <div>Type</div>
              <div>Amount</div>
              <div>Balance</div>
              <div style={{ minWidth: "210px" }}>Remark</div>
            </div>

            <div className="tx-table-blog">
              {rows.map((r) => {
                const isCredit = String(r.txn_type).toUpperCase() === "CREDIT";
                return (
                  <div className="tx-row-blog" key={r.id}>
                    {/* {userId && (
                                        <div>
                                            <div style={{ fontWeight: 700 }}>{r.user_name}</div>
                                            <div className="tx-muted">
                                                ({r.user_username}) • {r.user_role_name}
                                            </div>
                                        </div>
                                    )} */}
                    <div>
                      <div style={{ fontWeight: 700 }}>
                        {r.created_at
                          ? moment
                              .utc(r.created_at)
                              .local()
                              .format("DD/MM/YYYY hh:mm A")
                          : "—"}
                      </div>
                    </div>
                    <div>
                      <div style={{ fontWeight: 700 }}>
                        {(() => {
                          const ref = r?.reference_id;
                          if (ref == null || ref === "") return "—";
                          const s = String(ref);
                          return s.length > 13 ? `${s.slice(0, 13)}...` : s;
                        })()}
                      </div>
                      <div className="tx-muted">{r.reference_type || "-"}</div>
                    </div>
                    <div style={{ fontWeight: 700 }}>{r.txn_type}</div>
                    <div
                      className={`tx-amount ${isCredit ? "credit" : "debit"}`}
                    >
                      {isCredit ? "+" : "-"}
                      {r.amount}
                    </div>
                    <div>
                      <div style={{ fontWeight: 700 }}>{r.balance_after}</div>
                      <div className="tx-muted">Before: {r.balance_before}</div>
                    </div>
                    <div style={{ minWidth: "210px" }}>{r.remark || "-"}</div>
                  </div>
                );
              })}
            </div>

            {pagination && pagination.totalPages > 1 && (
              <div className="modern-pagination">
                {/* Limit Selector */}
                <div className="mp-limit">
                  <span>Show</span>
                  <select
                    value={limit}
                    onChange={(e) => setLimit(e.target.value)}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                  </select>
                </div>

                {/* Navigation */}
                <div className="mp-controls">
                  <button
                    disabled={page === 1}
                    onClick={() => setPage(page - 1)}
                  >
                    Prev
                  </button>

                  <div className="mp-info">
                    Page <strong>{pagination.page}</strong> of{" "}
                    <strong>{pagination.totalPages}</strong>
                  </div>

                  <button
                    disabled={page === pagination.totalPages}
                    onClick={() => setPage(page + 1)}
                  >
                    Next
                  </button>
                </div>

                {/* Jump to Page */}
                <div className="mp-jump">
                  <select
                    value={page}
                    onChange={(e) => setPage(e.target.value)}
                  >
                    {Array.from({ length: pagination.totalPages }, (_, i) => (
                      <option key={i + 1} value={i + 1}>
                        Page {i + 1}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default BalanceLog;
